import { createUseStyles } from '@pushpay/styles';
export const useStyles = createUseStyles(theme => {
  const getColors = displayStyle => {
    switch (displayStyle) {
      case 'neutral':
        return [theme.colors['palette-grey-dark-200'], theme.colors['palette-grey-light-200']];

      case 'product':
        return [theme.colors['product-color'], theme.colors['product-color-light-400']];

      case 'unstyled':
      default:
        return [undefined, undefined];
    }
  };

  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    menuItem: ({
      displayStyle,
      isSelected,
      disableSelection,
      selectionStyle
    }) => {
      const baseStyles = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'stretch',
        minHeight: 56,
        padding: `${theme.SPACING.GUTTER} ${theme.SPACING.SMALL}`,
        whiteSpace: 'normal',
        textAlign: 'left'
      };

      if (disableSelection) {
        return baseStyles;
      }

      const [selectedColor, selectedBackgroundColor] = getColors(displayStyle);
      const showSelectedBorder = isSelected && selectionStyle !== 'background';
      return { ...baseStyles,
        ...theme.OUTLINE.INTERACTIVE_ELEMENT_FOCUS_VISIBLE,
        background: isSelected ? selectedBackgroundColor : undefined,
        boxShadow: showSelectedBorder ? `inset 5px 0 0 0 ${selectedColor}` : undefined,
        cursor: 'pointer',
        '&:hover, &:focus': {
          backgroundColor: selectedBackgroundColor
        }
      };
    },
    menuItemMainContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    menuItemLeftContent: {
      display: 'flex',
      alignItems: 'center'
    },
    menuItemLeftElement: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0
    },
    menuItemRightContent: {
      display: 'flex',
      alignItems: 'center'
    },
    menuItemExtraContent: {
      display: 'flex',
      paddingTop: '12px'
    },
    menuItemLabel: ({
      hasLeftElement,
      hasRightElement
    }) => ({
      paddingLeft: hasLeftElement ? theme.SPACING.GUTTER : undefined,
      paddingRight: hasRightElement ? theme.SPACING.GUTTER : undefined
    }),
    menuItemSelectedIcon: ({
      displayStyle,
      hasRightElement
    }) => {
      const [selectedColor] = getColors(displayStyle);
      return {
        color: selectedColor,
        marginLeft: hasRightElement ? theme.SPACING.GUTTER : undefined
      };
    }
  };
});